import React from 'react';
import { lazy } from 'react-loosely-lazy';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries';
import { ISSUE_CREATE_MODAL_BODY_SELECTOR } from '@atlassian/jira-issue-create-commons';

import { useTriggerIssueCreateModal } from '@atlassian/jira-packages-controllers-use-trigger-issue-create-modal';
import Placeholder from '@atlassian/jira-placeholder';
import type { Payload } from './common/types';
import { useInitializePersistentIssueCreateModalView } from './controllers/use-initialize-persistent-issue-create-modal-view';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const IssueCreateModal = lazy(
	() => import(/* webpackChunkName: "async-jira-issue-create" */ './index'),
	{ ssr: false },
);

export const AsyncIssueCreateModal = () => (
	<JSErrorBoundary
		id="async.jira.issue-create-modal"
		packageName="jiraIssueCreate"
		sendToPrivacyUnsafeSplunk
	>
		<Placeholder name="issue-create-modal" fallback={<></>}>
			<IssueCreateModal />
		</Placeholder>
	</JSErrorBoundary>
);

// eslint-disable-next-line jira/export/no-external-exports
export {
	ISSUE_CREATE_MODAL_BODY_SELECTOR,
	useInitializePersistentIssueCreateModalView,
	useTriggerIssueCreateModal,
};
export type { Payload };
